export const truncate = (text: string = '', limit: number = 100) =>
  text ? text.slice(0, limit) : text;
